<template>
  <div>
    <div
      class="modal fade"
      id="modal-daily-checkin"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-modal="scroll"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content bg-congratulation">
          <button type="button" class="close" @click="closeModal()">
            <span aria-hidden="true"><i class="icon dripicons-cross"></i></span>
          </button>
          <div class="gold"></div>

          <div class="modal-body">
            <div class="ribbon-wrapper animate__animated animate__bounceIn">
              <div class="ribbon">
                <div class="ribbon-content letter-spacing">
                  {{ $t("completed-0") }}
                </div>
              </div>
            </div>

            <h3 class="ribbon-title">{{ $t("daily-login-task") }}</h3>
            <div>
              <h5>{{ $t("daily-login-reward") }}</h5>
              <div class="gift-wrap">
                <div class="gift-icon">
                  <div
                    class="icon-box icon-box-solid icon-radius bg-warning w-50"
                  >
                    <i class="icon dripicons-ticket"></i>
                  </div>
                </div>
                <div class="gift-text m-text msu-semibold">
                  <div>{{ $t("ticket") }}</div>
                  <span>+1</span>
                </div>
              </div>
            </div>
            <!-- <div class="mt-4">
              <h5>本月累積簽到 10 次</h5>
              <div class="gift-wrap">
                <div class="gift-icon">
                  <div
                    class="icon-box icon-box-solid icon-radius bg-warning w-50"
                  >
                    <i class="icon dripicons-jewel"></i>
                  </div>
                </div>
                <div class="gift-text m-text msu-semibold">
                  <p>經驗值</p>
                  <span>+1000</span>
                </div>
              </div>
            </div> -->
          </div>
          <div class="modal-footer border-none">
            <button
              @click="closeModal()"
              type="button"
              class="btn btn-primary btn-block btn-md"
            >
              {{ $t("ok") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const closeModal = () => {
  $("#modal-daily-checkin").modal("hide");
};
</script>
<style lang="scss"></style>
